<template>
  <div class="page">
    <HomeMast />
    <div class="section-group">
      <HomeSectionImages />
      <HomeSectionSecurity />
    </div>
  </div>
</template>

<script>
import HomeMast from '@/components/home/HomeMast'
import HomeSectionImages from '@/components/home/HomeSectionImages'
import HomeSectionSecurity from '@/components/home/HomeSectionSecurity'

export default {
  name: 'Home',
  components: {
    HomeMast,
    HomeSectionImages,
    HomeSectionSecurity
  }
}
</script>

<style lang="scss" scoped>
.section-group {
  background-color: #F5F5F5;
  padding: 80px 0 100px;
  @media screen and (max-width: 768px) {
    padding: 90px 0 120px;
  }
  @media screen and (max-width: 540px) {
    padding: 50px 0 100px;
  }
}
</style>